import React, { useState, useCallback, useEffect, useRef } from "react";
import { CrudModal, MasterTable } from "../../components/_index";
import {
  Box,
  Button,
  Dialog,
  Typography,
  TextField,
  Autocomplete,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import { showToast } from "../../redux/Reducer/toastReducer";
import DoneIcon from "@mui/icons-material/Done";
import { useDispatch } from "react-redux";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import { TICKET_TYPE_STATUS } from "../../constant/constant";
import Styles from "../Transaction/Transaction.module.scss";
import { deleteTicket, getTicket } from "../../services/ticket.service";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import NearMeIcon from "@mui/icons-material/NearMe";
import { DatePicker } from "antd";
import {
  getCaseHistory,
  publicHolidays,
  updateCaseHistory,
} from "../../services/caseHistory.service";
import EditIcon from "@mui/icons-material/Edit";
import { getTimeStatus } from "../../utils/TimeDifference";

const CaseHistory = () => {
  const { RangePicker } = DatePicker;
  const [data, setData] = useState([]);
  const [tableTotalCount, setTableCount] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [publicHoliday, setPublicHoliday] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();

  // Get default tab from navigation state (from Dashboard cards)
  const defaultTabFromState = location.state?.defaultTab;
  const defaultSearchFromState = location.state?.searchTaskNumber || "";
  const isFromReport = location.state?.isFromReport;

  const [selectedTab, setSelectedTab] = useState(defaultTabFromState || TICKET_TYPE_STATUS.PENDING);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("MM-DD-YYYY")
  );
  const webUserId =
    localStorage.getItem("userId") || localStorage.getItem("userid");
  const role = localStorage.getItem("role");
  const [selectedStartDate, setSelectedStartDate] = useState(
    isFromReport ? null : dayjs().startOf("month")
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    isFromReport ? null : dayjs().endOf("month")
  );
  const navigate = useNavigate();

  const [queryParam, setQueryParam] = useState({
    search: defaultSearchFromState,
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    startDate: isFromReport ? "" : dayjs().startOf("month").format("DD-MM-YYYY"),
    endDate: isFromReport ? "" : dayjs().endOf("month").format("DD-MM-YYYY"),
    type: selectedTab,
    webUserId,
    role,
  });

  function areAllStatusesAllowed(arr) {
    const filteredData = arr?.replyMessages?.filter((itm) => itm?.sendStatus && itm?.flag);
    if (filteredData?.length) {
      return true;
    } else {
      const filteredData = arr?.filter((itm) => itm?.sendStatus && itm?.flag);
      if (filteredData?.length) {
        return false;
      } else {
        return true;
      }
    }
  }
  function areAllStatusesAllowed2(arr) {
    const allowedStatuses = ["10"];
    return arr?.every((item) =>
      allowedStatuses.includes(String(item.sendStatus))
    );
  }

  function calculateWorkingSeconds(start, end) {
    const s = moment(start).clone();
    const e = moment(end).clone();

    if (!s.isValid() || !e.isValid() || !s.isBefore(e)) return 0;

    const holidaySet = new Set(publicHoliday);
    let totalSeconds = 0;

    // iterate day-by-day (fast even for long ranges)
    let day = s.clone().startOf("day");
    const lastDay = e.clone().startOf("day");

    while (day.isSameOrBefore(lastDay)) {
      const dayKey = day.format("YYYY-MM-DD");
      const isoDay = day.isoWeekday(); // 1 = Mon ... 7 = Sun

      // include Mon(1) - Sat(6) only and exclude holidays
      if (isoDay >= 1 && isoDay <= 6 && !holidaySet.has(dayKey)) {
        const workStart = day.clone().hour(9).minute(0).second(0);
        const workEnd = day.clone().hour(18).minute(0).second(0);

        // segment = overlap between [s,e) and [workStart, workEnd)
        const segStart = moment.max(s, workStart);
        const segEnd = moment.min(e, workEnd);

        if (segStart.isBefore(segEnd)) {
          totalSeconds += segEnd.diff(segStart, "seconds");
        }
      }

      day.add(1, "day");
    }

    return totalSeconds;
  }

  const searchData = async (query2) => {
    setOpenLoader(true)
    const res = await getCaseHistory({ ...queryParam, ...query2 });
    // Pre-calculate frequently used values outside the loop
    const formatDate = (date) =>
      date ? moment(date).format("DD MMM YYYY hh:mm:ss a") : "NA";
    const getModeType = (mode) =>
      mode === "0" ? "Direct" : mode === "1" ? "Mail" : "QR";
    const getStatusName = (sendStatus) =>
      sendStatus === "2"
        ? "Initial"
        : sendStatus === "3"
          ? "Follow Up"
          : sendStatus === "4"
            ? "Final"
            : "";
    const modifiedData = (res?.data || []).map((e) => {
      // Calculate timeGap only if needed
      function formatHms(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        return `${hrs}h ${mins}m ${secs}s`;
      }

      /* === Usage === */
      let timeGap = "",
        completedTime = "";
      if (e?.createdAt && e?.assignedAt) {
        const workingSeconds = calculateWorkingSeconds(
          e.createdAt,
          e.assignedAt
        );
        const workingCompletionHrs = e?.closedAt ? calculateWorkingSeconds(e?.assignedAt, e?.closedAt) : "-"

        timeGap = formatHms(workingSeconds);
        completedTime = e?.closedAt ? formatHms(workingCompletionHrs) : "-";
      }

      // Calculate hoursOfAssigned (time from createdAt to assignedAt)
      const created = moment(e?.createdAt || e?.ticketCreatedAt);
      const assigned = moment(e?.assignedAt);
      const diffInHours =
        assigned.isValid() && created.isValid()
          ? assigned.diff(created, "minutes") / 60
          : null;
      const totalMinutes = Math.ceil(
        assigned.diff(created, "seconds") / 60
      );
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      const readableDuration =
        hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

      // Calculate assignedToCompletedDuration if assignedAt and closedAt exist
      let assignedToCompletedDuration = "";
      if (e?.assignedToCompletedDuration) {
        // Use backend's calculated value (already in HH:MM:SS format)
        assignedToCompletedDuration = e.assignedToCompletedDuration;
      } else if (e?.assignedAt && e?.closedAt) {
        // Fallback to frontend calculation if backend doesn't provide it
        const workingSeconds = calculateWorkingSeconds(
          moment(e.assignedAt),
          moment(e.closedAt)
        );
        const hours = Math.floor(workingSeconds / 3600);
        const minutes = Math.floor((workingSeconds % 3600) / 60);
        const seconds = workingSeconds % 60;
        // Format as HH:MM:SS to match backend format
        assignedToCompletedDuration = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      }

      // Calculate no_of_msg_rec and no_of_msg_send from replyMessages
      const no_of_msg_rec = e?.replyMessages?.filter(
        (msg) => msg?.userId?.toString() === e?.createdBy?.toString()
      ).length || 0;
      const no_of_msg_send = e?.replyMessages?.filter(
        (msg) => msg?.userId?.toString() !== e?.createdBy?.toString()
      ).length || 0;

      // Determine subHistoryStatus with less nesting
      let subHistoryStatus;
      if (e?.subHistory?.length >= 1 && e?.type == 2) {
        const allAllowed = areAllStatusesAllowed(e.subHistory);
        subHistoryStatus = allAllowed ? 1 : 2;
      }

      return {
        ...e,
        createdAt: formatDate(e.assignedAt || e.createdAt),
        ticketCreatedAt: formatDate(e.createdAt),
        updatedAt: formatDate(e.updatedAt),
        assignedAt: formatDate(e.assignedAt),
        closedAt: formatDate(e.closedAt),
        assignedTo: e?.assignedToInfo?.name || "-",
        assignedBy: e?.assignedByInfo?.name || "-",
        createdByName: e?.createdByName,
        createdByEmail: e?.createdByInfo?.email,
        modeType: getModeType(e.mode),
        conversation:
          e?.createdBy ===
            e?.replyMessages?.[e.replyMessages.length - 1]?.userId
            ? "IN"
            : "OUT",
        StatusName: getStatusName(e.sendStatus),
        subHistoryStatus,
        timeGap,
        completedTime,
        ticket_status: e?.ticketStatus == "0" ? "Open" : "Closed",
        hoursOfAssigned: readableDuration,
        workingDuration: e?.workingDuration || readableDuration,
        no_of_msg_rec_send: `${no_of_msg_rec} / ${no_of_msg_send}`,
        assignedToCompletedDuration,
      };
    });

    setData(modifiedData);
    setTableCount(res?.totalCount || 0);
    setOpenLoader(false)
  }
  const fetchData = useCallback(async () => {
    try {
      setOpenLoader(true);

      // Parallelize API calls since they don't depend on each other
      const [ress, res] = await Promise.all([
        getTicket(),
        getCaseHistory(queryParam),
      ]);

      // Pre-calculate frequently used values outside the loop
      const formatDate = (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm:ss a") : "NA";
      const getModeType = (mode) =>
        mode === "0" ? "Direct" : mode === "1" ? "Mail" : "QR";
      const getStatusName = (sendStatus) =>
        sendStatus === "2"
          ? "Initial"
          : sendStatus === "3"
            ? "Follow Up"
            : sendStatus === "4"
              ? "Final"
              : "";

      const modifiedData = (res?.data || []).map((e) => {
        // Calculate timeGap only if needed
        function formatHms(seconds) {
          const hrs = Math.floor(seconds / 3600);
          const mins = Math.floor((seconds % 3600) / 60);
          const secs = Math.floor(seconds % 60);
          return `${hrs}h ${mins}m ${secs}s`;
        }

        /* === Usage === */
        let timeGap = "",
          completedTime = "-";
        if (e?.createdAt && e?.assignedAt) {
          const workingSeconds = calculateWorkingSeconds(
            e.createdAt,
            e.assignedAt
          );
          const workingCompletionHrs = e?.closedAt ? calculateWorkingSeconds(
            e.assignedAt,
            e.closedAt
          ) : "-";
          timeGap = formatHms(workingSeconds);
          completedTime = e?.closedAt ? formatHms(workingCompletionHrs) : "-";
        }

        // Calculate hoursOfAssigned (time from createdAt to assignedAt)
        const created = moment(e?.createdAt || e?.ticketCreatedAt);
        const assigned = moment(e?.assignedAt);
        const diffInHours =
          assigned.isValid() && created.isValid()
            ? assigned.diff(created, "minutes") / 60
            : null;
        const totalMinutes = Math.ceil(
          assigned.diff(created, "seconds") / 60
        );
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const readableDuration =
          hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

        // Calculate assignedToCompletedDuration if assignedAt and closedAt exist
        let assignedToCompletedDuration = "";
        if (e?.assignedToCompletedDuration) {
          // Use backend's calculated value (already in HH:MM:SS format)
          assignedToCompletedDuration = e.assignedToCompletedDuration;
        } else if (e?.assignedAt && e?.closedAt) {
          // Fallback to frontend calculation if backend doesn't provide it
          const workingSeconds = calculateWorkingSeconds(
            moment(e.assignedAt),
            moment(e.closedAt)
          );
          const hours = Math.floor(workingSeconds / 3600);
          const minutes = Math.floor((workingSeconds % 3600) / 60);
          const seconds = workingSeconds % 60;
          // Format as HH:MM:SS to match backend format
          assignedToCompletedDuration = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
        }

        // Calculate no_of_msg_rec and no_of_msg_send from replyMessages
        const no_of_msg_rec = e?.replyMessages?.filter(
          (msg) => msg?.userId?.toString() === e?.createdBy?.toString()
        ).length || 0;
        const no_of_msg_send = e?.replyMessages?.filter(
          (msg) => msg?.userId?.toString() !== e?.createdBy?.toString()
        ).length || 0;

        // Determine subHistoryStatus with less nesting
        let subHistoryStatus;
        if (e?.subHistory?.length >= 1 && e?.type == 2) {
          const allAllowed = areAllStatusesAllowed(e.subHistory);
          subHistoryStatus = allAllowed ? 1 : 2;
        }

        return {
          ...e,
          createdAt: formatDate(e.assignedAt || e.createdAt),
          ticketCreatedAt: formatDate(e.createdAt),
          updatedAt: formatDate(e.updatedAt),
          assignedAt: formatDate(e.assignedAt),
          closedAt: formatDate(e.closedAt),
          assignedTo: e?.assignedToInfo?.name || "-",
          assignedBy: e?.assignedByInfo?.name || "-",
          createdByName: e?.createdByName,
          createdByEmail: e?.createdByInfo?.email,
          modeType: getModeType(e.mode),
          conversation:
            e?.createdBy ===
              e?.replyMessages?.[e.replyMessages.length - 1]?.userId
              ? "IN"
              : "OUT",
          StatusName: getStatusName(e.sendStatus),
          subHistoryStatus,
          timeGap,
          completedTime,
          ticket_status: e?.ticketStatus == "0" ? "Open" : "Closed",
          hoursOfAssigned: readableDuration,
          workingDuration: e?.workingDuration || readableDuration,
          no_of_msg_rec_send: `${no_of_msg_rec} / ${no_of_msg_send}`,
          assignedToCompletedDuration,
        };
      });

      setData(modifiedData);
      setTableCount(res?.totalCount || 0);
    } catch (error) {
      console.error(error);
      setData([]);
      setTableCount(0);
    } finally {
      setOpenLoader(false);
    }
  }, [queryParam]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData();
    }, 300); // Add slight debounce to avoid rapid successive calls

    return () => clearTimeout(timer);
  }, [selectedStartDate, selectedEndDate, queryParam]);

  useEffect(() => {
    setData([]);
    setOpenLoader(true);
    setQueryParam((prev) => ({ ...prev, type: selectedTab, page: 1 }));
  }, [selectedTab]);

  useEffect(() => {
    setData([]);
    setOpenLoader(true);
  }, [queryParam.search, queryParam.date]);

  // useEffect(() => {
  //   if (openLoader) {
  //     const timer = setTimeout(() => {
  //       fetchData();
  //     }, 0);
  //     return () => clearTimeout(timer);
  //   }
  // }, [openLoader, fetchData]);

  const handleTabChange = (tab) => {
    setSearchValue("")
    setSelectedTab(tab);
    setData([])
  };

  const baseColumns = [
    { id: "ticketCreatedAt", label: "Received Date" },
    { id: "assignedAt", label: "Assigned Date" },
    { id: "timeGap", label: "Time gap" },
    { id: "completedTime", label: "Completion duration" },
    { id: "ticketId", label: "Ticket ID" },
    { id: "createdByName", label: "Name" },
    { id: "subject", label: "Subject", Styles: "masterTableTextWrap" },
    { id: "modeType", label: "Mode" },
  ];

  const subHistoryColumn = [
    { id: "status", label: "Status" },
    { id: "timer", label: "Timer" },
    { id: "description", label: "Description" },
  ];

  const filteredBaseColumns =
    selectedTab === "2"
      ? baseColumns.filter(
        (col) => col.id !== "timeGap" || col.id !== "completedTime"
      ) // remove 'timeGap' when selectedTab is 2
      : baseColumns;

  const assignedColumns =
    selectedTab === "2"
      ? [
        ...filteredBaseColumns,
        { id: "closedAt", label: "Completed Time" },
        { id: "assignedTo", label: "Assigned To" },
        { id: "ticket_status", label: "Status" },
        { id: "remarks", label: "Remark" },
      ]
      : [
        ...baseColumns,
        { id: "assignedTo", label: "Assigned To" },
        { id: "remarks", label: "Remark" },
      ];

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openAssignDrawer, setOpenAssignDrawer] = useState(false);
  const [infoModel, setOpenInfoModel] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [subHistory, setSubHistory] = useState([]);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);
  const [rejectedReason, setRejectedReason] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const searchTimeoutRef = useRef(null);
  const [searchValue, setSearchValue] = useState(defaultSearchFromState);
  const typeData = [
    {
      label: "Open",
      value: "0",
    },
    {
      label: "Closed",
      value: "1",
    },
  ];

  const deleteFunction = async () => {
    try {
      const res = await deleteTicket(selectedDataId);
      setConfirmDeleteOpen(false);
      setData([]);
      setOpenLoader(true);
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };




  const handleCancel = (e) => {
    setOpenAssignDrawer(true);
    setRejectedReason("");
    setSelectedData(e);
  };

  const handleNavigate = (e) => {
    // Remove React components before navigating (same as ServiceRequest)
    const {
      assignTimer,
      initialTimer,
      followUpTimer,
      finalTimer,
      timer,
      ...cleanData
    } = e;
    navigate("/feedback", { state: cleanData });
  };

  const handleModelOpen = (ele) => {
    setOpenInfoModel(true);
    setSelectedData(ele);
    const mod = ele?.subHistory?.map((e) => ({
      status:
        e?.sendStatus == "2"
          ? "Initial"
          : e?.sendStatus == "4"
            ? "Final"
            : e?.sendStatus == "5"
              ? "Need Info"
              : e?.sendStatus == "10"
                ? "Re-assigned"
                : e?.sendStatus == "11"
                  ? "Issue from officer"
                  : e?.sendStatus == "13"
                    ? "Issue from officer"
                    : "From staff",
      timer: getTimeStatus(ele?.createdAt, e?.date, 1),
      description: e?.description,
      flag: e?.flag,
    }));
    setSubHistory(mod);
  };

  const tableActionButton1 = [
    {
      title: "Remark",
      onClick: handleCancel,
      btnIcon: <EditIcon sx={{ color: "#00675d" }} />,
    },
  ];

  const tableActionButton2 = [
    {
      title: "Model Open",
      onClick: handleModelOpen,
      btnIcon: <InfoIcon sx={{ color: "#00675d" }} />,
    },
    {
      title: "Navigate",
      onClick: handleNavigate,
      btnIcon: <NearMeIcon sx={{ color: "#00675d" }} />,
    },
    {
      title: "Remark",
      onClick: handleCancel,
      btnIcon: <EditIcon sx={{ color: "#00675d" }} />,
    },
  ];

  const cancelFunction = async () => {
    if (rejectedReason === "") {
      dispatch(
        showToast({ message: "Please enter rejected reason", type: "error" })
      );
    } else {
      try {
        const payload = { remarks: rejectedReason };
        await updateCaseHistory(selectedData._id, payload);
        setOpenAssignDrawer(false);
        setOpenLoader(true);
        await fetchData();
      } catch (error) {
        console.log(error);
      }
    }
  };


  const handleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((prev) => ({ ...prev, search: searchText, page: 1 }));
    }, 500),
    []
  );

  const getPublicHolidays = async () => {
    try {
      const res = await publicHolidays();
      const modData = res?.data?.map((e) => e?.day ? moment(e.day).format("YYYY-MM-DD") : false).filter(Boolean);
      setPublicHoliday(modData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPublicHolidays();
  }, []);

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((prev) => ({ ...prev, ...params }));
  }, []);

  return (
    <div className="mainContent">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        mb={2}
      >
        <Tabs value={selectedTab}>
          <Tab
            label="UnAssigned"
            disabled={openLoader}
            className={
              selectedTab === TICKET_TYPE_STATUS.PENDING
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange("1")}
          />
          <Tab
            label="StaffConnect"
            disabled={openLoader}
            className={
              selectedTab === TICKET_TYPE_STATUS.ASSIGNED
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange("2")}
          />
        </Tabs>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {selectedTab == "2" && (
            <Grid item xs={2} sm={1}>
              <Autocomplete
                name="department"
                placeholder="Select Type"
                className="AutoComplete_InputBox"
                sx={{ width: "220px" }}
                options={typeData}
                value={selectedType}
                onChange={(e, v) => {
                  setSelectedType(v?.label);
                  setQueryParam((prev) => ({
                    ...prev,
                    ticketStatus: v?.value,
                  }));
                }}
                isOptionEqualToValue={(e, v) =>
                  e._id === v._id || e?.name === v
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    focused={false}
                    placeholder="Select Type"
                  />
                )}
              />
            </Grid>
          )}
          <Grid item xs={2} sm={1}>
            <RangePicker
              value={[selectedStartDate, selectedEndDate]}
              onChange={(e) => {
                setSelectedDate(e);
                setSelectedStartDate(dayjs(e?.[0]));
                setSelectedEndDate(dayjs(e?.[1]));
                setQueryParam((prev) => ({
                  ...prev,
                  startDate: dayjs(e?.[0]).format("DD-MM-YYYY"),
                  endDate: dayjs(e?.[1]).format("DD-MM-YYYY"),
                }));
              }}
              style={{ height: "38px", width: "220px" }}
            />
          </Grid>
          <Box className="SearchInputBoxContainer" sx={{ height: "100%" }}>
            <SearchOutlinedIcon className="Search_Icon" />
            <input
              className="SearchInputBox"
              value={searchValue}
              placeholder="Search here"
              onChange={(e) => {
                setSearchValue(e?.target?.value);
                handleSearch(e?.target?.value)
              }}
              style={{ height: "38px" }}
            />
          </Box>
        </Box>
      </Box>

      <MasterTable
        data={data}
        columns={assignedColumns}
        isServerSide={true}
        // tableActionButton={[
        //   {
        //     title: "Remark",
        //     onClick: handleCancel,
        //     btnIcon: <EditIcon sx={{ color: "#00675d" }} />,
        //   },
        // ]}
        tableActionButton={
          (selectedTab == "1" && tableActionButton1) ||
          (selectedTab == "2" && tableActionButton2)
        }
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
        openLoader={openLoader}
      />

      <CrudModal
        title="Add Remarks"
        open={openAssignDrawer}
        handleClose={() => setOpenAssignDrawer(false)}
        maxWidth="xs"
      >
        <Box>
          <TextField
            fullWidth
            placeholder="Enter Remarks"
            multiline
            rows={4}
            value={rejectedReason}
            onChange={(e) => setRejectedReason(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                padding: "20px 16px", // Larger vertical padding for the root
              },
              "& .MuiOutlinedInput-input": {
                padding: "0 4px", // Side spacing for the inner text
              }
            }}
          />
          <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
            <Button
              variant="contained"
              onClick={() => setOpenAssignDrawer(false)}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                px: 3,
                backgroundColor: "#d32f2f",
                "&:hover": {
                  backgroundColor: "#b71c1c",
                }
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={cancelFunction}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                px: 3,
                backgroundColor: "#00675d",
                "&:hover": {
                  backgroundColor: "#00564d"
                }
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </CrudModal>

      <Dialog
        open={infoModel}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="md"
      >
        <CrudModal
          title={"Info Model"}
          open={true}
          handleClose={() => {
            setOpenInfoModel(false);
          }}
          maxWidth="md"
        >
          <MasterTable
            data={subHistory}
            columns={subHistoryColumn}
            isServerSide={true}
            tableTotalCount={subHistory?.length}
            tableOutputEvent={tableOutputEvent}
            openLoader={openLoader}
            pagination={true}
          />
        </CrudModal>
      </Dialog>
    </div>
  );
};

export default CaseHistory;
